/** Keep chunks used by any unexpired version, including undo and other tabs.
 * Abandoned import chunks get a one-hour grace period before reclamation. */
export function cleanupDatasetStore(db: IDBDatabase, now = Date.now()): Promise<void> {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(['datasets', 'chunks', 'indexes'], 'readwrite');
    tx.oncomplete = () => resolve(); tx.onabort = () => reject(tx.error); tx.onerror = () => reject(tx.error);
    const live = new Set<string>();
    const datasets = tx.objectStore('datasets').openCursor();
    datasets.onsuccess = () => {
      const cursor = datasets.result;
      if (cursor) {
        const value: { expiresAt: number; parts: Array<{ id: string }> } = cursor.value;
        if (value.expiresAt <= now) cursor.delete();
        else for (const part of value.parts) live.add(part.id);
        cursor.continue(); return;
      }
      const chunks = tx.objectStore('indexes').openCursor();
      chunks.onsuccess = () => {
        const index = chunks.result;
        if (!index) return;
        const value: { createdAt?: number } = index.value;
        if (!live.has(String(index.key)) && (value.createdAt ?? now) < now - 60 * 60 * 1000) {
          tx.objectStore('chunks').delete(index.key); index.delete();
        }
        index.continue();
      };
    };
  });
}

export function discardDatasetChunks(db: IDBDatabase, ids: string[]): Promise<void> {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(['chunks', 'indexes'], 'readwrite');
    tx.oncomplete = () => resolve(); tx.onabort = () => reject(tx.error); tx.onerror = () => reject(tx.error);
    for (const id of ids) { tx.objectStore('chunks').delete(id); tx.objectStore('indexes').delete(id); }
  });
}
